import React from 'react';
import {Link} from 'react-router-dom';
import styled from 'styled-components';

const ButtonStyle = styled.div`
  margin-top: 2.5rem;

  .button {
    font-size: 2.2rem;
    background-color: ${(props) =>
            props.outline ? 'transperant' : 'white'};
    padding: 0.7em 2em;
    border: ${(props) =>
            props.outline ? "2px solid white" : 'white'};;
    border-radius: 8px;
    //display: inline-block;
    //color: #504b4b;
    color: ${(props) =>
            props.outline ? 'white' : '#504b4b'};
    transition: all 0.3s ease 0s;

  }

  .button:hover {
    background-color: #504b4b;
    color: white
  }


  @media only screen and (max-width: 768px) {
    .button {
      font-size: 1.8rem;
    }
  }
`;

const Button = ({
                    btnText = 'test',
                    btnLink = 'test',
                    outline = false,
                }) => {
    return (
        <ButtonStyle outline={outline} className='button-wrapper'>
            <Link className='button' to={btnLink}>
                {btnText}
                {/*${(props) => (props.outline ? 'black' : 'black')}*/}
            </Link>
        </ButtonStyle>
    );
}
export default React.memo(Button)
